export default {
  apiGateway: {
    REGION: "eu-north-1",
    //URL: "https://uazhytrvhl.execute-api.eu-north-1.amazonaws.com/Prod", // Stage
    URL: "https://tkx5glq166.execute-api.eu-north-1.amazonaws.com/Prod", // Prod
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_Jm8w6WCpo",
    APP_CLIENT_ID: "rcakrt7ec4640i20tdjepsgeu",
    IDENTITY_POOL_ID: "eu-central-1:5847a642-0148-4709-a13f-cab3231bd843",
  },
};
